import React from 'react';
import { Leaf } from 'lucide-react';
export function BotanicalDivider() {
  return <div className="flex items-center justify-center py-2 opacity-40" data-id="element-475">
      <div className="h-px w-16 bg-[#4A5D3A]" data-id="element-476"></div>
      <Leaf className="mx-4 text-[#4A5D3A]" size={20} strokeWidth={1.5} data-id="element-477" />
      <div className="h-px w-16 bg-[#4A5D3A]" data-id="element-478"></div>
    </div>;
}